"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _rememberedAccounts = require("./rememberedAccounts");
Object.keys(_rememberedAccounts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _rememberedAccounts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _rememberedAccounts[key];
    }
  });
});